
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { AddBox, AddLinkOutlined, Clear } from "@mui/icons-material";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import moment from "moment";

import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../dataConfig";
import { DesktopDatePicker } from "@mui/lab";
import { DateTimePicker } from "@mui/x-date-pickers";
import BreakEntry from "./BreakEntry";
import { Add } from "@mui/icons-material";
import { toast } from "react-toastify";
import NormalTable from "../../../Component/NormalTable";
import ErrorProps from "../../../Component/Errorprops";

const ShiftModal = ({ mode, handleCloseClick, editData, getData }) => {
  const [loading, setLoading] = useState(false);
  const [breaks, setBreaks] = useState(mode === "Edit" ? editData.shiftBreakList || [] : []);

  const initialValue = {
    name: mode === "Edit" ? editData.name : "",
    code: mode === "Edit" ? editData.code : "",
    startTime: mode === "Edit" ? editData.startTime : "",
    endTime: mode === "Edit" ? editData.endTime : "",
    durationInHours: mode === "Edit" ? editData.durationInHours : "",
    breaks: breaks.length > 0 ? breaks : [{ startTime: "", endTime: "", durationInHours: "" }]
  };


  const handleAddBreak = () => {
    setBreaks([...breaks, { startTime: "", endTime: "", durationInHours: "", breakName: "", code: "" }]);
  };

  const handleBreakChange = (index, field, value) => {
    const newBreaks = [...breaks];
    newBreaks[index][field] = value;
  
    // If either startTime or endTime is updated, calculate the duration
    if (field === "startTime" || field === "endTime") {
      const { startTime, endTime } = newBreaks[index];
  
      if (startTime && endTime) {
        const start = dayjs(startTime, "HH:mm:ss");
        const end = dayjs(endTime, "HH:mm:ss");
  
        if (end.isAfter(start)) {
          const diff = end.diff(start, "minute"); // Get difference in minutes
          const hours = Math.floor(diff / 60);
          const minutes = diff % 60;
          newBreaks[index].durationInHours = `${hours}h ${minutes}m`;
        } else {
          newBreaks[index].durationInHours = "0h 0m";
        }
      }
    }
  
    setBreaks(newBreaks);
  };
  
  const handleDeleteBreak = async(id, index) => {
    if (!id) {
      setBreaks((prevBreaks) => prevBreaks.filter((_, i) => i !== index));
      return;
    }
  
    const barkdelete = masterAPI['shift'].delete;
    setLoading(true);
    await axiosPrivate 
    .delete(`${barkdelete}/${id}`)
    .then(()=>{
      handleCloseClick();
      getData()
     })
    .catch((e)=>{
      console.log(e,'error')
      setLoading(false);
     })
  };
  const confirmDelete = (id, index) => {
      toast(
        <Grid>
          <Typography sx={{fontSize:"15px",fontWeight:600, color:"#797979"}}>Are you sure you want to delete?</Typography>
          <Grid item container spacing={2}>
            <Grid item>
              <Button
                onClick={() => {
                  handleDeleteBreak(id, index);
                  toast.dismiss();
                }}
                sx={{ color: "grey", borderColor: "green" }}
                size="small"
                variant="outlined"
              >
                Yes
              </Button>
            </Grid>
            <Grid item >
              <Button
                onClick={() => toast.dismiss()}
                sx={{ color: "grey", borderColor: "red" }}
                size="small"
                variant="outlined"
              >
                No
              </Button>
            </Grid>
          </Grid>
        </Grid>,
        {
          closeButton: false,
          autoClose: false,
        }
      );
    };
const columns = [
    // {
    //   accessor: "id",
    //   disableFilters: true,
    //   Cell: () => {
    //     return (
    //       <Box sx={{width:color.checkBoxWidth }}>
    //       <Checkbox
    //         // icon={<RadioButtonUncheckedOutlined />}
    //         // checkedIcon={<CheckCircle />}
    //       />
    //       </Box>
    //     );
    //   },
    // },
    // {
    //   Header: "Shift Code",
    //   accessor: "code",
    //   // disableFilters: true,
    //   Cell: ({ cell }) => {
    //     return (
    //       <Link
    //        // to={`/masters/failureclass/problem?id=${cell.row.original.id}`}
    //    //     onClick={()=>{dispatch({type:"failureClass",name:'failureClass',payload:cell.row.original.id})}}
    //         style={{
    //           color: "#0d6efd",
    //           textDecorationLine: "underline",
    //           fontWeight: 800,
    //         }}
    //       >
    //         {cell.value}
    //       </Link>
    //     );
    //   },
    // },
    {
      Header: "Break Name",
      accessor: "breakName",
      // disableFilters: true,
    },
    // {
    //     Header: "Start Time",
    //     accessor: "startTime",
    //     // disableFilters: true,
    //   },
    // {
    //     Header: "End Time",
    //     accessor: "endTime",
    //     // disableFilters: true,
    // },
    // {
    //     Header: "Duration In Hours",
    //     accessor: "durationInHours",
    //     // disableFilters: true,
    // },
    // {
    //   Header: "Actions",
    //   Cell: ({ cell }) => {
    //     // console.log(cell)
    //     return (
    //       <Box sx={{ whiteSpace: "nowrap" }}>
    //         <IconButton disabled={!actionsAllow.edit}>
    //           <EditOutlined
    //             onClick={() => {
    //               handleEdit(cell.row.original);
    //             }}
    //             sx={{
    //               fontSize: color.masterEditDelButton,
    //               color: actionsAllow.edit? color.masterEditDelButtonColor:"default",
    //             }}
    //           />
    //         </IconButton>
    //         {/* <IconButton disabled={!actionsAllow.delete}>
    //           <DeleteOutline
    //             onClick={() => {
    //               handleDelete(cell.row.original.id);
    //             }}
    //             sx={{
    //               fontSize: color.masterEditDelButton,
    //               color: actionsAllow.delete? color.masterEditDelButtonColor:"default",
    //             }}
    //           />
    //         </IconButton> */}
    //         <Switch
    //         disabled={!actionsAllow.delete}
    //         checked={cell.row.original.isActive}
    //         onChange={(e)=>{handleDelete(e,cell.row.original.id)}}
           
    //          />
    //       </Box>
    //     );
    //   },
    // },
  ];

  const onSubmit = async (value) => {

    console.log(value);
    setLoading(true);
    const createLink = masterAPI["shift"].create;
    const updateLink = masterAPI["shift"].update;
    const shiftBreakList = breaks.map((breakItem) => ({
      ...(breakItem.id ? { id: breakItem.id } : {}),
      code: breakItem.code,
      breakName: breakItem.breakName,
      startTime: breakItem.startTime,
      endTime: breakItem.endTime,
      durationInHours: breakItem.durationInHours,
  }));
    const payload = {
      ...value,
      shiftBreakList, 
    };

    if (mode === "Create") {
      console.log(payload,"create")
      await axiosPrivate
        .post(`${createLink}`, payload)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
            toast.error(e.response.data.failureMessage)
          console.log(e, "createShift");
        });
    } else {
      const updateAC = {
        id: editData.id,
        ...payload,
      };
      console.log(updateAC,'updateAC')
      await axiosPrivate
        .put(`${updateLink}`, updateAC)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
           if(e.response.data.FailureMessage)
                    {
                            toast.error("Code is already exists")
                    }
          console.log(e, "updateShift");
        });
    }
  };
 const validationSchema = Yup.object().shape({

  code:Yup.string().required("Code is required"),
  name:Yup.string().required("Name is required"),
    startTime:Yup.string().required("Start Time is required"),
    endTime:Yup.string().required("End Time is required"),
 });
  const handleCancel = () => {
    handleCloseClick();
  };

  const handleStartTimeChange = (time, setFieldValue, values) => {
    const formattedTime = time ? time.format("HH:mm:ss") : "";
    setFieldValue("startTime", formattedTime);
  
    // Reset end time if it is before the new start time
    if (values.endTime && dayjs(values.endTime, "HH:mm:ss").isBefore(dayjs(formattedTime, "HH:mm:ss"))) {
      setFieldValue("endTime", "");
    }
  
    // Auto-calculate duration if endTime is set
    if (values.endTime) {
      calculateDurationtime(formattedTime, values.endTime, setFieldValue);
    }
  };
  
  const handleEndTimeChange = (time, setFieldValue, values) => {
    const formattedTime = time ? time.format("HH:mm:ss") : "";
    setFieldValue("endTime", formattedTime);
  
    // Calculate duration
    if (values.startTime) {
      calculateDurationtime(values.startTime, formattedTime, setFieldValue);
    }
  };
  
  const calculateDurationtime = (startTime, endTime, setFieldValue) => {
    const start = dayjs(startTime, "HH:mm:ss");
    const end = dayjs(endTime, "HH:mm:ss");
  
    if (end.isAfter(start)) {
      const diff = end.diff(start, "minute"); // Get difference in minutes
      const hours = Math.floor(diff / 60);
      const minutes = diff % 60;
      setFieldValue("durationInHours", `${hours}h ${minutes}m`);
    } else {
      setFieldValue("durationInHours", "");
    }
  };
  

  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit" ? editData.code + "-" + editData.name : "New Shift"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue}validationSchema={validationSchema} onSubmit={onSubmit}>
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <Grid container spacing={"1rem"}>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Shift Code
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="code"
                  placeholder="Enter Shift Code"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      "&::placeholder": {
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                 <ErrorMessage name="code">
                                                {(error) => <ErrorProps>{error}</ErrorProps>}
                                              </ErrorMessage>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Shift Name
                </Typography>
                <Field
                  as={TextField}
                  size="small"
                  type="text"
                  name="name"
                  placeholder="Enter Shift Name"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      "&::placeholder": {
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
                 <ErrorMessage name="name">
                                                {(error) => <ErrorProps>{error}</ErrorProps>}
                                              </ErrorMessage>
              </Grid>

              <Grid item xs={12} md={6}>
  <Typography sx={{ fontWeight: color.labelFontWeight, mb: color.labelmb, fontSize: color.labelFont, color: color.labelColor }}>
    Start Time
  </Typography>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Field name="startTime">
      {({ field, form }) => (
        <TimePicker
          value={field.value ? dayjs(field.value, "HH:mm:ss") : null}
          ampm={false}
          onChange={(time) => handleStartTimeChange(time, form.setFieldValue, form.values)}
          slotProps={{
            textField: { size: "small", fullWidth: true },
          }}
        />
      )}
    </Field>
      <ErrorMessage name="startTime">
                                                {(error) => <ErrorProps>{error}</ErrorProps>}
                                              </ErrorMessage>
  </LocalizationProvider>
</Grid>

<Grid item xs={12} md={6}>
  <Typography sx={{ fontWeight: color.labelFontWeight, mb: color.labelmb, fontSize: color.labelFont, color: color.labelColor }}>
    End Time
  </Typography>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Field name="endTime">
      {({ field, form }) => (
        <TimePicker
          value={field.value ? dayjs(field.value, "HH:mm:ss") : null}
          onChange={(time) => handleEndTimeChange(time, form.setFieldValue, form.values)}
          ampm={false}

          minTime={form.values.startTime ? dayjs(form.values.startTime, "HH:mm:ss") : undefined} 

          slotProps={{
            textField: { size: "small", fullWidth: true },
          }}
        />
      )}
    </Field>
      <ErrorMessage name="endTime">
                                                {(error) => <ErrorProps>{error}</ErrorProps>}
                                              </ErrorMessage>
  </LocalizationProvider>
</Grid>

<Grid item xs={12} md={6}>
<Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
       Total Duration:  {values.durationInHours || "0h 0m"}
        </Typography>

  {/* <Field
    as={TextField}
    size={"small"}
    name="durationInHours"
    placeholder="Duration"
    fullWidth
    disabled
    sx={{
      ".MuiInputBase-input": {
        "&::placeholder": { opacity: 1, color: color.placeholderColor, fontSize: "13px" },
      },
    }}
  /> */}
</Grid>


              <Grid item xs={12}>
              <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
         Break List
        </Typography>
        <IconButton onClick={handleAddBreak}>
          <Add />
        </IconButton>
      </Box>
              <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)" }} />
              </Grid>
              
              <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                <Grid item>
                  <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  
                </Typography>
                  </Grid>
                  <Grid item xs={2}>
                  <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Break Code
                </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Break Name
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Start Time
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      End Time
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography
                      sx={{
                        fontWeight: color.labelFontWeight,
                        fontSize: color.labelFont,
                        color: color.labelColor,
                      }}
                    >
                      Duration
                    </Typography>
                  </Grid>
                  
                </Grid>

                {/* Break Entries */}
                {breaks.map((breakItem, index) => (
                  <BreakEntry
                    key={index}
                    breakItem={breakItem}
                    index={index}
                    handleBreakChange={handleBreakChange}
                    handleDeleteBreak={confirmDelete}
                  />
                ))}

                {/* Add Break Button */}
                {/* <Button onClick={handleAddBreak} sx={{ marginTop: "10px" }}>
                  Add Break
                </Button> */}
              </Grid>

              <Grid item xs={12} textAlign="right">
                <Button
                  sx={{
                    textTransform: "capitalize",
                    color: color.formButtonColor,
                    fontSize: "15px",
                    padding: "8px 16px",
                    backgroundColor: color.formButtonBackgroundColor,
                    ":hover": {
                      backgroundColor: color.formButtonHoverBackgroundColor,
                    },
                  }}
                  type="submit"
                >
                  {loading ? <CircularProgress size={20} color="inherit" /> : "Submit"}
                </Button>
              </Grid>
              
                {/* <NormalTable data={breaks} columns={columns}/> */}
             
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default ShiftModal;

